export const SELECT_ALL = 'Mailboxes/Segments/SELECT_ALL'
export const UNSELECT_ALL = 'Mailboxes/Segments/UNSELECT_ALL'
